module.exports = __webpack_public_path__ + "img/icone-fale-conosco.5eeeb2ac.png";